// extracted by mini-css-extract-plugin
export default {"container":"PageLoade_container__scmQ3"};